import { capitalizeFirstLetter } from '@utils/stringFormat';

const SUCCESS_STATUS = 'success';
const NAME_FIELD = 'name';

interface MemberFieldError {
  field: string;
  message: string;
}

interface MemberErrorHolder {
  errors?: MemberFieldError[];
}

interface MoveToCofeeResponseBody {
  status?: string;
  data?: {
    member_response?: MemberErrorHolder[];
    members_added?: { members?: MemberErrorHolder[] };
    branch_members?: { members?: MemberErrorHolder[] };
  };
}

interface MoveToCofeeErrorResponse {
  data?: {
    errors?: MemberFieldError[];
  };
}

export type MoveToCofeeResult =
  | { type: 'success' }
  | { type: 'nameError'; message: string }
  | { type: 'toastError'; message?: string };

const getMemberErrors = (body: MoveToCofeeResponseBody): MemberFieldError[] => {
  const members =
    body?.data?.member_response ||
    body?.data?.members_added?.members ||
    body?.data?.branch_members?.members ||
    [];
  return members.flatMap((member) => member.errors ?? []);
};

const findNameErrorMessage = (errors: MemberFieldError[]): string | null => {
  const nameError = errors.find((error) => error.field === NAME_FIELD);
  return nameError ? capitalizeFirstLetter(nameError.message) : null;
};

export const parseMoveToCofeeResponse = (
  responseBody: unknown
): MoveToCofeeResult => {
  const body = (responseBody ?? {}) as MoveToCofeeResponseBody;
  if (body.status === SUCCESS_STATUS) return { type: 'success' };

  const errors = getMemberErrors(body);
  if (errors.length === 0) return { type: 'success' };

  const nameMessage = findNameErrorMessage(errors);
  if (nameMessage) return { type: 'nameError', message: nameMessage };
  return { type: 'toastError', message: errors[0]?.message };
};

export const getNameFieldErrorMessage = (error: unknown): string | null => {
  const errors = (error as MoveToCofeeErrorResponse)?.data?.errors ?? [];
  return findNameErrorMessage(errors);
};
